<template>
  <v-select
    v-model="model"
    :variant="realTimeMode ? 'underlined' : 'outlined'"

    color="secondary"
    :menu-icon="appendIcon"
    :label="labelName"
    :items="items"
    item-title="language_name"
    item-value="id"

    :name="fieldKey"
    :hint="hint"
    :error-messages="errorMessages"
    :disabled="disabled"

    @keyup.enter="$emit('enter')"
  />
</template>

<script>
  import axios from 'axios'
  import settings from '@/settings'
  import InputMixin from './InputMixin'

  export default {
    mixins: [InputMixin],
    props: {
      realTimeMode: Boolean
    },
    emits: ['update:model-value', 'enter'],
    data: () => ({
      model: null,
      items: [],
      appendIcon: null
    }),
    computed: {
      labelName () {
        if (this.realTimeMode) {
          return null
        } else {
          return this.required ? '*' + this.$t('User.Language') : this.$t('User.Language')
        }
      }
    },
    watch: {
      model () {
        if (this.realTimeMode) {
          this.$i18n.locale = this.model
        } else {
          this.$emit('update:model-value', this.model)
        }
      }
    },
    created () {
      if (this.realTimeMode) {
        this.appendIcon = 'mdi-web'
      }
      axios.get(settings.ApiUrl + 'languages/', { params: { limit: 1000 } }).then((res) => {
        this.items = res.data.results
        // デフォルト値は現在表示している言語とする
        this.model = this.modelValue ? this.modelValue : this.$i18n.locale
      })
    },
    mounted () {}
  }
</script>
